import { FILTER_NAME_SUB_MENU } from '../../constants/filter'

export const QA_NAME_NEWSBOARD_PAGE = 'newsboard'

export const QA_NAME_POST_ADD_NEW = 'addNewPost'

export const POST_LIST_ALL_TAB = 'all'

export const POST_LIST_TAB_NEWSBOARD = 'newsboard'

export const POST_LIST_TAB_REQUEST = 'request'

export const EXCLUDE_FILTERS = [FILTER_NAME_SUB_MENU]

export const CREATE_POST_ACTION_NAME = 'createPost'
